/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const UpdatesIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="UpdatesIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.8204 3.11613C13.9342 3.21113 14 3.35174 14 3.5V11.5C14 11.6483 13.9342 11.7889 13.8204 11.8839C13.7065 11.9789 13.5564 12.0185 13.4106 11.9919L6 10.6446V14H5V10.4627L2.41056 9.99194C2.17281 9.94871 2 9.74165 2 9.5V5.5C2 5.25836 2.17281 5.0513 2.41056 5.00807L13.4106 3.00807C13.5564 2.98155 13.7065 3.02113 13.8204 3.11613ZM3 5.91729V9.08272L13 10.9009V4.09911L3 5.91729Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

UpdatesIcon.tags = [
  'announce',
  'megaphone',
  'new',
  'broadcast',
  'speaker',
  'alert',
  'notification',
];

UpdatesIcon.category = 'General Icons';

UpdatesIcon.iconSize = 16;
